import { render, staticRenderFns } from "./LsProductFeedback.vue?vue&type=template&id=65ec140e&scoped=true&"
import script from "./LsProductFeedback.vue?vue&type=script&lang=js&"
export * from "./LsProductFeedback.vue?vue&type=script&lang=js&"
import style0 from "./LsProductFeedback.vue?vue&type=style&index=0&id=65ec140e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ec140e",
  null
  
)

export default component.exports